/** Keep admission checks ahead of the durable first-message mirror as well as
 * HTTP dispatch. The reader is live so long-lived transports do not retain an
 * expired entitlement or an old account's access. */
export function guardSubmittedTurn<T>(
  allow: () => boolean,
  remember: (messages: T) => Promise<void>,
) {
  return async (messages: T) => {
    if (!allow()) throw new Error('payment_required');
    await remember(messages);
  };
}
